import { Injectable } from '@angular/core';

@Injectable()
export class DoneShapeTemplatesService {

  public shapes : any = {
    rectangle: [
      {x: 109.12366548042706, y: -151.7871148459384, depth: 15},
      {x: 109.12366548042706, y: 127.82072829131653, depth: 15},
      {x: -274.2838078291815, y: 127.82072829131653, depth: 15},
      {x: -274.2838078291815, y: -151.7871148459384, depth: 15}
    ],
    l_shape: [
      { x: -113.05604982206398, y: -129.81792717086836, depth: 15 },
      { x: -113.05604982206398, y: 48.93137254901961, depth: 15 },
      { x: 98.3096085409253, y: 48.93137254901961, depth: 15 },
      { x: 98.3096085409253, y: 246.65406162464984, depth: 15 },
      { x: -275.26690391459067, y: 246.65406162464984, depth: 15 },
      { x: -275.26690391459067, y: -129.81792717086836, depth: 15 }
    ],
    u_shape: [
      { x: -142.5489323843416, y: -174.7549019607843, depth: 15 },
      { x: -142.5489323843416, y: -6.990196078431362, depth: 15 },
      { x: 19.66192170818514, y: -6.990196078431362, depth: 15 },
      { x: 19.66192170818514, y: -174.7549019607843, depth: 15 },
      { x: 150.4137010676158, y: -174.7549019607843, depth: 15 },
      { x: 150.4137010676158, y: 149.7899159663866, depth: 15 },
      { x: -276.25, y: 149.7899159663866, depth: 15 },
      { x: -276.25, y: -174.7549019607843, depth: 15 }
    ],
    t_shape: [   
      { x: 48.171708185053376, y: -73.89635854341736, depth: 15 },
      { x: -51.12099644128111, y: -73.89635854341736, depth: 15 },
      { x: -51.12099644128111, y: 177.75070028011208, depth: 15 },
      { x: -199.5685053380783, y: 177.75070028011208, depth: 15 },
      { x: -199.5685053380783, y: -73.89635854341738, depth: 15 },
      { x: -305.74288256227754, y: -73.89635854341738, depth: 15 },
      { x: -305.74288256227754, y: -175.75350140056017, depth: 15 },
      { x: 48.171708185053376, y: -175.75350140056017, depth: 15 }
    ],
    cut_angle: [
      { x: -548.8395725804131, y: -185.46879332682622, depth: 15 },
      { x: -422.8648936149344, y: -185.46879332682622, depth: 15 },
      { x: -119.01016013232214, y: 118.38594015578539, depth: 15 },
      { x: -119.01016013232214, y: 219.26723223754, depth: 15 },
      {x: -548.8395725804131, y: 219.26723223754, depth: 15 }
    ],
    octagonal: [
      { x: 127.80249110320291, y: -112.84173669467788, depth: 15 },
      { x: 127.80249110320288, y: 24.96498599439775, depth: 15 },
      { x: 21.62811387900355, y: 112.84173669467786, depth: 15 },
      { x: -176.9572953736655, y: 112.84173669467786, depth: 15 },
      { x: -283.13167259786474, y: 24.964985994397765, depth: 15 },
      { x: -283.13167259786474, y: -112.84173669467786, depth: 15 },
      { x: -176.9572953736655, y: -200.71848739495795, depth: 15 },
      { x: 21.62811387900355, y: -200.71848739495798, depth: 15 }
    ],
    // DockRail mode templates: long narrow piers instead of deck footprints
    dock_straight: [
      { x: 300, y: -75, depth: 15 },
      { x: 300, y: 75, depth: 15 },
      { x: -300, y: 75, depth: 15 },
      { x: -300, y: -75, depth: 15 }
    ],
    dock_l: [
      { x: 300, y: -60, depth: 15 },
      { x: 300, y: 60, depth: 15 },
      { x: -180, y: 60, depth: 15 },
      { x: -180, y: 300, depth: 15 },
      { x: -300, y: 300, depth: 15 },
      { x: -300, y: -60, depth: 15 }
    ],
    dock_t: [
      { x: 300, y: -60, depth: 15 },
      { x: 300, y: 60, depth: 15 },
      { x: -180, y: 60, depth: 15 },
      { x: -180, y: 200, depth: 15 },
      { x: -300, y: 200, depth: 15 },
      { x: -300, y: -200, depth: 15 },
      { x: -180, y: -200, depth: 15 },
      { x: -180, y: -60, depth: 15 }
    ],
    dock_f: [
      { x: 300, y: -60, depth: 15 },
      { x: 300, y: 60, depth: 15 },
      { x: 60, y: 60, depth: 15 },
      { x: 60, y: 300, depth: 15 },
      { x: -60, y: 300, depth: 15 },
      { x: -60, y: 60, depth: 15 },
      { x: -180, y: 60, depth: 15 },
      { x: -180, y: 300, depth: 15 },
      { x: -300, y: 300, depth: 15 },
      { x: -300, y: -60, depth: 15 }
    ],
    // U-Shape: wide arms around a short open bay
    dock_u: [
      { x: 300, y: -200, depth: 15 },
      { x: 300, y: -70, depth: 15 },
      { x: -60, y: -70, depth: 15 },
      { x: -60, y: 70, depth: 15 },
      { x: 300, y: 70, depth: 15 },
      { x: 300, y: 200, depth: 15 },
      { x: -300, y: 200, depth: 15 },
      { x: -300, y: -200, depth: 15 }
    ],
    // Slip: narrow walkways around a long boat slip
    dock_slip: [
      { x: 300, y: -200, depth: 15 },
      { x: 300, y: -80, depth: 15 },
      { x: -180, y: -80, depth: 15 },
      { x: -180, y: 80, depth: 15 },
      { x: 300, y: 80, depth: 15 },
      { x: 300, y: 200, depth: 15 },
      { x: -300, y: 200, depth: 15 },
      { x: -300, y: -200, depth: 15 }
    ],
    dock_platform: [
      { x: 150, y: -150, depth: 15 },
      { x: 150, y: 150, depth: 15 },
      { x: -150, y: 150, depth: 15 },
      { x: -150, y: -150, depth: 15 }
    ]
  };

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/done-shape-templates.service.ts